module.exports = __webpack_public_path__ + "static/media/manage_marketing_permissions.7a07032d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab-images/manage_marketing_permissions.jpg
// module id = 214
// module chunks = 0